import MaterialIcon from '@/components/atom/MaterialIcon';

import { sanitizeHtml } from '@/entities/medicine-dictionary/util';
import { cn } from '@/utils/style';
import { Button } from 'doctornow-design-system';
import { useState } from 'react';
import HealthMedicalMedicines from '../../../../public/images/medicine-dictionary/healthMedicalMedicines.svg';

interface Props {
  simplifiedName?: string;
  dosages?: string[];
  dosageHtml?: string;
}

const MedicineGuideDosage = (props: Props) => {
  const shouldShowDosageHtml = props.dosageHtml && props.dosageHtml.length > 0;
  const shouldShowButton = props.dosageHtml && props.dosageHtml.length > 0;
  const [isDescriptionExpended, setIsDescriptionExpended] = useState(false);

  const toggleDescriptionExpended = () => {
    setIsDescriptionExpended(!isDescriptionExpended);
  };

  return (
    <section className={cn('flex flex-col gap-[20px] px-[24px] py-[28px]')}>
      <div className='flex items-center gap-[8px]'>
        <HealthMedicalMedicines className='shrink-0' />
        <h2 className={cn('typography-ui-19sb shrink-1 select-text text-gray-700')}>
          {props.simplifiedName}, 용법/용량
        </h2>
      </div>
      <div className={cn('flex flex-col ')}>
        {props.dosages?.map((dosageInfo) => {
          return (
            <div key={`dosage-${dosageInfo}`} className='flex flex-col gap-[12px]'>
              <ul className='flex flex-col gap-[12px]'>
                <li
                  className={cn([
                    'typography-ui-15r select-text text-gray-700',
                    'relative pl-[20px]',
                    'before:absolute before:top-[10px] before:left-[6px] before:h-[4px] before:w-[4px] before:rounded-full before:bg-gray-700 before:content-[""]',
                    'flex gap-[8px]',
                  ])}
                  key={`dosageInfo-${dosageInfo}`}
                >
                  {dosageInfo}
                </li>
              </ul>
            </div>
          );
        })}

        {shouldShowDosageHtml && isDescriptionExpended && (
          <div
            className={cn([
              'mt-[20px] flex w-full flex-col gap-[12px]',
              'typography-ui-15r select-text text-gray-700',
              'rounded-[12px] bg-gray-20 p-[20px]',
            ])}
            dangerouslySetInnerHTML={{
              __html: sanitizeHtml(props.dosageHtml || ''),
            }}
          />
        )}
      </div>
      {shouldShowButton && (
        <Button
          buttonStyle={'outlined'}
          buttonColor='gray'
          size='m'
          className={cn(['w-full transition-all duration-300 ease-in-out', 'hover:scale-[1.02]active:scale-[0.98]'])}
          type='button'
          onClick={toggleDescriptionExpended}
        >
          <div className='ease flex items-center gap-2 transition-all duration-300'>
            <span className='typography-ui-15sb text-gray-600'>{isDescriptionExpended ? '접기' : '자세히 보기'}</span>
            <div
              className={cn([
                'ease transition-transform duration-300',
                isDescriptionExpended ? 'rotate-180' : 'rotate-0',
              ])}
            >
              <MaterialIcon name={'keyboard_arrow_down'} size={20} />
            </div>
          </div>
        </Button>
      )}
    </section>
  );
};

export default MedicineGuideDosage;
